
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/[policyUrlName]",
      function () {
        return require("private-next-pages/policies/[policyUrlName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/[policyUrlName]"])
      });
    }
  